<template>
  <div class="detail-containter">
    <nav-bar />
    <div class="detail-body">
      <div class="containter">
        <!-- 面包屑 + 返回 -->
        <div class="detail-crumb">
          <a class="back-btn" @click="goBack" aria-label="返回">
            <i class="el-icon-back"></i>
            <span>返回</span>
          </a>
          <div class="crumb-text">
            <span @click="goHelp" class="crumb-link">帮助中心</span>
            <span class="crumb-sep">/</span>
            <span class="crumb-current">详情</span>
          </div>
        </div>

        <!-- 文档卡片 -->
        <div class="detail-card">
          <div class="detail-title">{{ title || '申请保函流程' }}</div>
          <div v-if="!detail && staticDoc" class="detail-content" v-html="staticDoc"></div>
          <div v-else class="detail-content" v-html="detail"></div>
        </div>
      </div>
    </div>
    <site-footer />
  </div>
</template>

<script>
import NavBar from '@/components/NavBar'
import SiteFooter from '@/components/SiteFooter'

import { getDetail, getDetailByToken } from './../lib/api/index'

export default {
  components: { NavBar, SiteFooter },
  name: 'detail',
  data () {
    return {
      id: -1,
      title: '',
      detail: '',
      // 静态兜底文档：API 无数据时使用
      staticDoc: `
<h2>一、选择标段与产品</h2>
<ol>
  <li>登录账号，进入「<strong>项目标段</strong>」页面。</li>
  <li>使用顶部搜索框按「标段名称 / 编号」检索，或点击「<strong>高级筛选</strong>」按地区、类型、状态精准筛选。</li>
  <li>根据您的业务类型，选择对应的电子保函产品（电子投标保函、履约保函、预付款保函、农民工工资支付保函等）。</li>
  <li>在列表中点击目标标段卡片，核对「交易中心、标段编号、开标时间、保证金金额」无误后，点击「<strong>立即申请</strong>」按钮进入申请页。</li>
</ol>

<h2>二、填写申请信息</h2>
<ol>
  <li>根据页面提示，依次填写：
    <ul>
      <li>申请人信息（姓名、身份证、联系方式）</li>
      <li>企业信息（企业名称、统一社会信用代码）</li>
      <li>项目相关信息（标段编号会自动带入）</li>
      <li>选择「授信模式」或「保证金模式」，并填写申请金额</li>
    </ul>
  </li>
  <li>上传所需附件（营业执照、身份证、近 6 个月纳税证明等，具体以页面要求为准）。</li>
  <li>确认所有信息填写无误，点击「<strong>下一步</strong>」进入信息确认页。</li>
</ol>

<h2>三、信息确认</h2>
<ol>
  <li>在确认页再次核对所有申请信息。</li>
  <li>勾选并阅读《<strong>电子保函申请协议</strong>》与《<strong>用户隐私政策</strong>》。</li>
  <li>点击「<strong>提交申请</strong>」，系统将进行自动化审核。</li>
</ol>

<h2>四、订单查看与缴费</h2>
<ol>
  <li>提交申请后，进入「<strong>个人中心 → 我的订单</strong>」即可查看订单审核进度。</li>
  <li>订单状态说明：
    <table>
      <thead>
        <tr>
          <th>状态类别</th>
          <th>状态值</th>
          <th>说明</th>
        </tr>
      </thead>
      <tbody>
        <tr><td rowspan="4">审批状态</td><td>申请中</td><td>订单刚提交，等待机构审核</td></tr>
        <tr><td>已申请</td><td>审核通过，等待出函</td></tr>
        <tr><td>已取消</td><td>用户主动撤销或审核未通过</td></tr>
        <tr><td>已完成</td><td>保函已成功出具</td></tr>
        <tr><td rowspan="4">缴费状态</td><td>待缴费</td><td>订单审核通过，需要完成缴费</td></tr>
        <tr><td>未缴费</td><td>暂未发起缴费</td></tr>
        <tr><td>已超时</td><td>超过缴费时限，请联系客户经理</td></tr>
        <tr><td>已缴费</td><td>费用已支付，等待出具保函</td></tr>
      </tbody>
    </table>
  </li>
  <li>订单支持的操作：
    <ul>
      <li><strong>查看</strong>：查看订单详细信息</li>
      <li><strong>撤销</strong>：审核通过前可主动撤销订单</li>
      <li><strong>支付</strong>：审核通过后在线完成缴费</li>
      <li><strong>理赔</strong>：在保函履约期间发生理赔时申请理赔</li>
      <li><strong>申请发票</strong>：缴费完成后可申请开具发票</li>
    </ul>
  </li>
</ol>

<h2>五、温馨提示</h2>
<ul>
  <li>电子保函与纸质保函具有同等法律效力，请放心使用。</li>
  <li>遇到任何问题，可点击页面右侧「<strong>联系客户经理</strong>」或拨打 <strong>19179363419（蒋经理）</strong> / <strong>0793-3409556</strong> 获取一对一协助。</li>
  <li>保函出具后，可通过首页「<strong>保函真伪查询</strong>」入口实时验证真伪。</li>
</ul>
`
    }
  },
  created () {
    if (this.$route.query.id) {
      this.id = this.$route.query.id
    }
    if (window.localStorage.getItem('token')) {
      getDetailByToken(this.$route.query.id).then(res => {
        if (res.code == 200) {
          this.detail = res.data.remark
          this.title = res.data.name
        }
      })
    } else {
      getDetail(this.$route.query.id).then(res => {
        if (res.code == 200) {
          this.detail = res.data.remark
          this.title = res.data.name
        }
      })
    }
  },
  methods: {
    // 返回上一页（带 fallback）
    goBack () {
      if (window.history.length > 1) {
        this.$router.back()
      } else {
        this.$router.push('/help')
      }
    },
    // 面包屑点击：跳到帮助中心
    goHelp () {
      this.$router.push('/help')
    }
  }
}
</script>

<style scoped lang="less">
@import '~@/assets/styles/variables.less';

.detail-containter {
  background: #F0F2F5;
  min-height: 100vh;

  .detail-body {
    padding: 20px 0;

    .containter {
      .detail-crumb {
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: #fff;
        padding: 12px 20px;
        border-radius: @radius-md;
        margin-bottom: 12px;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);

        .back-btn {
          display: inline-flex;
          align-items: center;
          gap: 4px;
          color: @primary;
          font-size: 14px;
          cursor: pointer;
          transition: opacity @duration-fast @ease-out;
          user-select: none;

          &:hover { opacity: 0.8; }

          i { font-size: 16px; }
        }

        .crumb-text {
          font-size: 13px;
          color: @text-muted;

          .crumb-link {
            color: @text-secondary;
            cursor: pointer;
            transition: color @duration-fast @ease-out;
            &:hover { color: @primary; }
          }
          .crumb-sep {
            margin: 0 8px;
            color: @border-base;
          }
          .crumb-current {
            color: @text-base;
          }
        }
      }

      .detail-card {
        background: #fff;
        padding: 30px 40px;
        border-radius: @radius-md;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);

        .detail-title {
          color: @text-strong;
          font-size: 22px;
          font-weight: bold;
          text-align: center;
          padding-bottom: 16px;
          border-bottom: 1px solid @border-light;
          margin-bottom: 24px;
        }

        .detail-content {
          font-size: 15px;
          color: @text-secondary;
          line-height: 1.9;
          text-align: justify;

          /deep/ h2 {
            color: @primary;
            font-size: 18px;
            border-left: 4px solid @primary;
            padding-left: 10px;
            margin: 24px 0 12px 0;
            font-weight: 600;
          }

          /deep/ ol,
          /deep/ ul {
            padding-left: 24px;
            margin: 8px 0;
          }

          /deep/ li {
            margin: 6px 0;
          }

          /deep/ table {
            width: 100%;
            border-collapse: collapse;
            margin: 12px 0;
            font-size: 14px;

            th, td {
              border: 1px solid @border-light;
              padding: 8px 12px;
              text-align: left;
            }

            thead th {
              background: @bg-soft;
              color: @text-strong;
              font-weight: 600;
            }

            tbody td {
              color: @text-secondary;
            }
          }

          /deep/ strong {
            color: @text-strong;
            font-weight: 600;
          }
        }
      }
    }
  }
}
</style>